export default __webpack_public_path__ + "static/media/Dice-3.d9000f96.png";